module.exports = {"445122100":"黄冈镇","445122102":"上饶镇","445122103":"饶洋镇","445122104":"新丰镇","445122106":"建饶镇","445122107":"三饶镇","445122108":"新塘镇","445122109":"汤溪镇","445122110":"浮滨镇","445122112":"浮山镇","445122113":"东山镇","445122114":"新圩镇","445122116":"樟溪镇","445122117":"钱东镇","445122118":"高堂镇","445122119":"联饶镇","445122120":"所城镇","445122121":"大埕镇","445122122":"柘林镇","445122123":"汫洲镇","445122124":"海山镇","445122400":"韩江林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445122.json
// module id = 1884
// module chunks = 0